export default __webpack_public_path__ + "static/media/movie-app.db295592.PNG";